import {
  call, put, takeLatest,
} from 'redux-saga/effects';
import api from '@/api/application';
import {
  ERROR_UPDATE_REQUEST,
  VALIDATION_ERROR_REQUEST,
} from '@/action-types/error';
import {
  LOADING_UPDATE_REQUEST,
} from '@/action-types/loading';
import {
  APPLICATION_SEND_REQUEST, APPLICATION_SEND_SUCCESS,
} from '@/action-types/application';

import { Action } from 'redux';
import { GA_SEND_EVENT } from '@/action-types/analytics';
import Cookies from 'js-cookie';

export function* checkDataErrors(e) {
  if (e.message === 'User Input Error') {
    yield put({ type: VALIDATION_ERROR_REQUEST, isActive: true, errorData: e });
  } else {
    yield put({ type: ERROR_UPDATE_REQUEST, isActive: true, errorData: e });
  }
}

export function* applicationSend(action: Action & {
  data: {
    name: string;
    company: string;
    email: string;
    phone: string;
  };
}) {
  try {
    yield call(api.sendApplication, action.data);

    yield put({ type: APPLICATION_SEND_SUCCESS, isSentSuccessfully: true });

    const lang = Cookies.get('language') || 'en';

    yield put({
      type: GA_SEND_EVENT,
      eventName: 'b2b_request',
      data: {
        event: `application_created_${lang}`,
      },
    });
  } catch (e) {
    yield checkDataErrors(e);
  } finally {
    yield put({ type: LOADING_UPDATE_REQUEST, name: 'application', state: false });
  }
}

export default function* login() {
  yield takeLatest(APPLICATION_SEND_REQUEST, applicationSend);
}
